import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FileQuestion, Home, Wrench } from 'lucide-react';

export default function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '100px 20px 120px', maxWidth: 560, margin: '0 auto' }}>
      <Helmet>
        <title>Page Not Found — ILoveConvert</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20, color: 'var(--primary)' }}>
        <FileQuestion size={64} strokeWidth={1.25} />
      </div>
      <h1 style={{ fontFamily: 'Sora, sans-serif', fontSize: '1.8rem', fontWeight: 800, marginBottom: 10 }}>
        Page Not Found
      </h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: 32, lineHeight: 1.6 }}>
        The page you're looking for doesn't exist or may have moved. Let's get you back on track.
      </p>
      <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link to="/" className="btn btn-primary">
          <Home size={16} /> Back to Home
        </Link>
        <Link to="/merge-pdf" className="btn btn-outline">
          <Wrench size={16} /> Start Converting
        </Link>
      </div>
    </div>
  );
}
